import { Helmet } from 'react-helmet-async';
import { useJednotkaQuery } from '../api/JsdhNotifikaceService/service/AdminMutations';

const DynamicTitle: React.FC = () => {
    const { data: jednotka } = useJednotkaQuery();

    const title = jednotka?.nazev || 'Hasiči Online';

    return (
        <Helmet>
            <title>{title} - HasičiOnline.cz</title>
            <meta name="description" content={`${title} - Notifikační systém pro dobrovolné hasiče`} />
            <meta name="apple-mobile-web-app-title" content={title} />
            <meta name="application-name" content={title} />
        </Helmet>
    );
};

export default DynamicTitle;
